import { Box, List, ListItem, Typography } from '@mui/material';
import type React from 'react';

export const UsageGuide: React.FC = () => {
  return (
    <Box sx={{ mb: 3, pl: 1 }}>
      <Typography variant="body2" sx={{ fontSize: '1rem', mb: 1 }}>
        <strong>Usage Guide:</strong>
      </Typography>
      <List
        dense
        sx={{
          listStyleType: 'disc',
          pl: 2,
          '& .MuiListItem-root': { display: 'list-item', py: 0.2, px: 0, fontSize: '1rem' },
        }}
      >
        <ListItem>
          <strong>Expand & Edit:</strong> Click any section to expand it and make manual edits.
        </ListItem>
        <ListItem>
          <strong>Add Sections:</strong> Hover between sections to add a new section and build it
          with the AI Assistant.
        </ListItem>
        <ListItem>
          <strong>AI Assistant:</strong> Use the AI Assistant for specific rewrites or to query
          sections of the text.
        </ListItem>
        <ListItem>
          <strong>Track Progress:</strong> Mark sections as 'Reviewed' to track your progress.
        </ListItem>
        <ListItem>
          <strong>Download:</strong> Update and save individual sections directly as DOCX.
        </ListItem>
      </List>
    </Box>
  );
};
